import firebase from 'firebase';
import config from '../config/app'
const firebaseApp = firebase.initializeApp(config.firebase);
export default firebaseApp



// WEBPACK FOOTER //
// ./src/firebase.js